import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.5 5.437a.562.562 0 1 0 1.125 0c0-.932.756-1.687 1.688-1.687h2.812v.562a.565.565 0 0 0 .962.4l1.125-1.126a.563.563 0 0 0 0-.796L8.087 1.665a.562.562 0 0 0-.962.397v.563H4.313A2.81 2.81 0 0 0 1.5 5.437m9 1.125a.562.562 0 1 0-1.125 0c0 .932-.756 1.688-1.687 1.688H4.874v-.563a.565.565 0 0 0-.962-.399L2.788 8.413a.563.563 0 0 0 0 .796l1.125 1.125a.563.563 0 0 0 .962-.4v-.56h2.813A2.81 2.81 0 0 0 10.5 6.563"
    }, null, -1)
  ]))]))
}
export default { render: render }